import { render, staticRenderFns } from "./VendorSidebar.vue?vue&type=template&id=ca9b6720&scoped=true"
import script from "./VendorSidebar.vue?vue&type=script&lang=js"
export * from "./VendorSidebar.vue?vue&type=script&lang=js"
import style0 from "./VendorSidebar.vue?vue&type=style&index=0&id=ca9b6720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9b6720",
  null
  
)

export default component.exports